// Unique editorial content per city: tagline, "why visit" and 3 highlights.
// Languages: en + tr; other locales fall back to English via getCityContent.

const CONTENT = {
  paris: {
    tagline: { en: "The City of Light", tr: "Işıklar Şehri" },
    why: {
      en: "Art, fashion and gastronomy at their most refined — every boulevard is a museum, every café a front-row seat to Parisian life.",
      tr: "Sanat, moda ve gastronominin en rafine hali — her bulvar bir müze, her kafe Paris yaşamına açılan ön sıra koltuğu.",
    },
    highlights: {
      en: ["Eiffel Tower & the Louvre", "Montmartre's artists' quarter", "Seine river cruises"],
      tr: ["Eyfel Kulesi ve Louvre", "Ressamlar mahallesi Montmartre", "Sen Nehri turları"],
    },
  },
  nice: {
    tagline: { en: "Queen of the Riviera", tr: "Riviera'nın Kraliçesi" },
    why: {
      en: "Azure water, Belle Époque promenades and Provençal markets — the French Riviera at its most graceful.",
      tr: "Lacivert deniz, Belle Époque kordonları ve Provence pazarları — Fransız Rivierası'nın en zarif hali.",
    },
    highlights: {
      en: ["Promenade des Anglais", "Old Town & Cours Saleya market", "Day trips to Monaco & Èze"],
      tr: ["Promenade des Anglais", "Eski Şehir ve Cours Saleya pazarı", "Monako ve Èze'ye günübirlik turlar"],
    },
  },
  lyon: {
    tagline: { en: "France's gastronomic capital", tr: "Fransa'nın gastronomi başkenti" },
    why: {
      en: "The birthplace of French cuisine, secret Renaissance passageways and two rivers framing a luminous old town.",
      tr: "Fransız mutfağının doğum yeri, gizli Rönesans geçitleri ve ışıklı eski şehri çevreleyen iki nehir.",
    },
    highlights: {
      en: ["Vieux Lyon & the traboules", "Traditional bouchon dining", "Fourvière Basilica views"],
      tr: ["Vieux Lyon ve traboule'lar", "Geleneksel bouchon restoranları", "Fourvière Bazilikası manzarası"],
    },
  },
  bordeaux: {
    tagline: { en: "The wine capital of the world", tr: "Dünyanın şarap başkenti" },
    why: {
      en: "Grand 18th-century facades, world-class vineyards at the city gates and the Cité du Vin — a pilgrimage for wine lovers.",
      tr: "Görkemli 18. yüzyıl cepheleri, şehrin kapısında dünya standardında bağlar ve Cité du Vin — şarap tutkunları için bir hac.",
    },
    highlights: {
      en: ["Cité du Vin", "Saint-Émilion vineyards", "Place de la Bourse & the water mirror"],
      tr: ["Cité du Vin", "Saint-Émilion bağları", "Place de la Bourse ve su aynası"],
    },
  },
  rome: {
    tagline: { en: "The Eternal City", tr: "Ebedi Şehir" },
    why: {
      en: "Twenty-eight centuries stacked into one open-air museum — Colosseum mornings, Trastevere evenings, espresso in between.",
      tr: "Tek bir açık hava müzesinde yığılmış 28 yüzyıl — sabah Kolezyum, akşam Trastevere, arada espresso.",
    },
    highlights: {
      en: ["Colosseum & Roman Forum", "Vatican & Sistine Chapel", "Evenings in Trastevere"],
      tr: ["Kolezyum ve Roma Forumu", "Vatikan ve Sistina Şapeli", "Trastevere akşamları"],
    },
  },
  milan: {
    tagline: { en: "Italy's style engine", tr: "İtalya'nın stil motoru" },
    why: {
      en: "Fashion, design and da Vinci's Last Supper — Italy's most cosmopolitan city pairs Gothic grandeur with aperitivo culture.",
      tr: "Moda, tasarım ve da Vinci'nin Son Akşam Yemeği — İtalya'nın en kozmopolit şehri, Gotik ihtişamı aperitivo kültürüyle birleştirir.",
    },
    highlights: {
      en: ["Duomo & Galleria Vittorio Emanuele II", "The Last Supper", "Navigli canal district"],
      tr: ["Duomo ve Galleria Vittorio Emanuele II", "Son Akşam Yemeği", "Navigli kanal bölgesi"],
    },
  },
  venice: {
    tagline: { en: "The floating masterpiece", tr: "Yüzen başyapıt" },
    why: {
      en: "No cars, no roads — marble palaces rising from the lagoon, gondola whispers and light painters chased for centuries.",
      tr: "Araba yok, yol yok — lagünden yükselen mermer saraylar, gondol fısıltıları ve ressamların yüzyıllarca peşinde koştuğu ışık.",
    },
    highlights: {
      en: ["St. Mark's Basilica", "Grand Canal by vaporetto", "Murano & Burano islands"],
      tr: ["San Marco Bazilikası", "Vaporetto ile Büyük Kanal", "Murano ve Burano adaları"],
    },
  },
  florence: {
    tagline: { en: "Cradle of the Renaissance", tr: "Rönesans'ın beşiği" },
    why: {
      en: "Michelangelo, Botticelli and Brunelleschi's dome — the world's greatest art concentrated in one walkable city.",
      tr: "Michelangelo, Botticelli ve Brunelleschi'nin kubbesi — dünyanın en büyük sanatı, yürünebilir tek şehirde toplanmış.",
    },
    highlights: {
      en: ["Uffizi Gallery", "Duomo & Brunelleschi's Dome", "Ponte Vecchio at sunset"],
      tr: ["Uffizi Galerisi", "Duomo ve Brunelleschi Kubbesi", "Gün batımında Ponte Vecchio"],
    },
  },
  madrid: {
    tagline: { en: "The city that stays up latest", tr: "En geç uyuyan şehir" },
    why: {
      en: "Royal palaces, the Prado's masterpieces and tapas crawls that last until dawn — Madrid lives loudly and late.",
      tr: "Kraliyet sarayları, Prado'nun başyapıtları ve şafağa dek süren tapas turları — Madrid gürültülü ve geç yaşar.",
    },
    highlights: {
      en: ["Prado Museum", "Royal Palace", "Tapas in La Latina"],
      tr: ["Prado Müzesi", "Kraliyet Sarayı", "La Latina'da tapas"],
    },
  },
  barcelona: {
    tagline: { en: "Gaudí's playground by the sea", tr: "Deniz kıyısında Gaudí'nin oyun alanı" },
    why: {
      en: "Sagrada Família's impossible spires, Mediterranean beaches and tapas bars — Catalan creativity at full volume.",
      tr: "Sagrada Família'nın imkânsız kuleleri, Akdeniz plajları ve tapas barları — son ses Katalan yaratıcılığı.",
    },
    highlights: {
      en: ["Sagrada Família & Park Güell", "The Gothic Quarter", "Barceloneta beach"],
      tr: ["Sagrada Família ve Park Güell", "Gotik Mahalle", "Barceloneta plajı"],
    },
  },
  sevilla: {
    tagline: { en: "The soul of Andalusia", tr: "Endülüs'ün ruhu" },
    why: {
      en: "Flamenco, orange-blossom patios and the Alcázar's Moorish arches — Spain's most passionate city.",
      tr: "Flamenko, portakal çiçeği kokulu avlular ve Alcázar'ın Mağribi kemerleri — İspanya'nın en tutkulu şehri.",
    },
    highlights: {
      en: ["Real Alcázar", "Plaza de España", "Flamenco in Triana"],
      tr: ["Real Alcázar", "Plaza de España", "Triana'da flamenko"],
    },
  },
  valencia: {
    tagline: { en: "Where paella was born", tr: "Paella'nın doğduğu yer" },
    why: {
      en: "A futuristic City of Arts and Sciences, golden beaches and the original paella — Spain's most liveable secret.",
      tr: "Fütüristik Sanat ve Bilim Şehri, altın plajlar ve orijinal paella — İspanya'nın en yaşanabilir sırrı.",
    },
    highlights: {
      en: ["City of Arts and Sciences", "Old Town & Central Market", "Malvarrosa beach"],
      tr: ["Sanat ve Bilim Şehri", "Eski Şehir ve Merkez Pazarı", "Malvarrosa plajı"],
    },
  },
  london: {
    tagline: { en: "The world's capital", tr: "Dünyanın başkenti" },
    why: {
      en: "Royal pageantry, West End theatres, free world-class museums and a food scene spanning every continent.",
      tr: "Kraliyet törenleri, West End tiyatroları, ücretsiz dünya çapında müzeler ve her kıtadan lezzetler.",
    },
    highlights: {
      en: ["British Museum & Tate Modern", "West End shows", "Buckingham to Tower Bridge"],
      tr: ["British Museum ve Tate Modern", "West End gösterileri", "Buckingham'dan Tower Bridge'e"],
    },
  },
  manchester: {
    tagline: { en: "The original modern city", tr: "Orijinal modern şehir" },
    why: {
      en: "Industrial heritage turned cultural powerhouse — legendary music, two football giants and reborn Victorian warehouses.",
      tr: "Kültürel güç merkezine dönüşen sanayi mirası — efsanevi müzik, iki futbol devi ve yeniden doğan Viktorya depoları.",
    },
    highlights: {
      en: ["Northern Quarter", "Old Trafford & the Etihad", "Science and Industry Museum"],
      tr: ["Northern Quarter", "Old Trafford ve Etihad", "Bilim ve Sanayi Müzesi"],
    },
  },
  edinburgh: {
    tagline: { en: "The Athens of the North", tr: "Kuzeyin Atinası" },
    why: {
      en: "A castle on volcanic rock, medieval closes off the Royal Mile and the world's largest arts festival every August.",
      tr: "Volkanik kayada bir kale, Royal Mile'a açılan orta çağ sokakları ve her Ağustos dünyanın en büyük sanat festivali.",
    },
    highlights: {
      en: ["Edinburgh Castle", "Royal Mile & Arthur's Seat", "The August festivals"],
      tr: ["Edinburgh Kalesi", "Royal Mile ve Arthur's Seat", "Ağustos festivalleri"],
    },
  },
  istanbul: {
    tagline: { en: "Where two continents meet", tr: "İki kıtanın buluştuğu yer" },
    why: {
      en: "Byzantine domes and Ottoman minarets, bazaars older than most nations, and a Bosphorus sunset you will never forget.",
      tr: "Bizans kubbeleri ve Osmanlı minareleri, çoğu ulustan yaşlı çarşılar ve asla unutamayacağınız bir Boğaz gün batımı.",
    },
    highlights: {
      en: ["Hagia Sophia & Blue Mosque", "The Grand Bazaar", "A Bosphorus cruise"],
      tr: ["Ayasofya ve Sultanahmet", "Kapalıçarşı", "Boğaz turu"],
    },
  },
  antalya: {
    tagline: { en: "The Turkish Riviera", tr: "Türk Rivierası" },
    why: {
      en: "Turquoise coves beneath the Taurus mountains, a Roman-harbour old town and 300 days of sunshine a year.",
      tr: "Torosların eteğinde turkuaz koylar, Roma limanlı bir eski şehir ve yılda 300 gün güneş.",
    },
    highlights: {
      en: ["Kaleiçi old town", "Konyaaltı & Lara beaches", "Düden waterfalls"],
      tr: ["Kaleiçi", "Konyaaltı ve Lara plajları", "Düden şelaleleri"],
    },
  },
  cappadocia: {
    tagline: { en: "A landscape from another planet", tr: "Başka bir gezegenden bir manzara" },
    why: {
      en: "A hundred balloons rising over fairy chimneys at dawn, cave hotels and underground cities carved two millennia ago.",
      tr: "Şafakta peribacalarının üzerinde yükselen yüzlerce balon, mağara oteller ve iki bin yıl önce oyulmuş yeraltı şehirleri.",
    },
    highlights: {
      en: ["Sunrise balloon flight", "Göreme Open-Air Museum", "Derinkuyu underground city"],
      tr: ["Gün doğumu balon uçuşu", "Göreme Açık Hava Müzesi", "Derinkuyu yeraltı şehri"],
    },
  },
  athens: {
    tagline: { en: "The birthplace of democracy", tr: "Demokrasinin doğum yeri" },
    why: {
      en: "The Acropolis glowing above a city that invented theatre, philosophy and the Mediterranean table.",
      tr: "Tiyatroyu, felsefeyi ve Akdeniz sofrasını icat eden şehrin üzerinde parlayan Akropolis.",
    },
    highlights: {
      en: ["Acropolis & Parthenon", "The Plaka district", "Acropolis Museum"],
      tr: ["Akropolis ve Parthenon", "Plaka semti", "Akropolis Müzesi"],
    },
  },
  santorini: {
    tagline: { en: "The Aegean's postcard", tr: "Ege'nin kartpostalı" },
    why: {
      en: "White villages stacked on a volcanic caldera, sunsets in Oia and vineyards growing from black lava soil.",
      tr: "Volkanik kalderaya dizilmiş beyaz köyler, Oia'da gün batımları ve siyah lav toprağında yetişen bağlar.",
    },
    highlights: {
      en: ["Sunset in Oia", "Caldera boat tour", "Red Beach & ancient Akrotiri"],
      tr: ["Oia'da gün batımı", "Kaldera tekne turu", "Red Beach ve antik Akrotiri"],
    },
  },
  lisbon: {
    tagline: { en: "The city of seven hills", tr: "Yedi tepeli şehir" },
    why: {
      en: "Vintage trams, azulejo tiles, fado echoing through Alfama and custard tarts still warm from the oven.",
      tr: "Nostaljik tramvaylar, azulejo çinileri, Alfama'da yankılanan fado ve fırından yeni çıkmış pastéis de nata.",
    },
    highlights: {
      en: ["Tram 28 & Alfama", "Belém Tower & pastéis", "LX Factory & Time Out Market"],
      tr: ["28 tramvayı ve Alfama", "Belém Kulesi ve pastéis", "LX Factory ve Time Out Market"],
    },
  },
  porto: {
    tagline: { en: "Port wine's hometown", tr: "Porto şarabının memleketi" },
    why: {
      en: "Riverside Ribeira's colourful stacks, port cellars across the Douro and a bookshop that inspired Hogwarts.",
      tr: "Ribeira'nın rengârenk yamaçları, Douro'nun karşı kıyısında Porto mahzenleri ve Hogwarts'a ilham veren kitapçı.",
    },
    highlights: {
      en: ["Ribeira & Dom Luís Bridge", "Vila Nova de Gaia cellars", "Livraria Lello"],
      tr: ["Ribeira ve Dom Luís Köprüsü", "Vila Nova de Gaia mahzenleri", "Livraria Lello"],
    },
  },
  amsterdam: {
    tagline: { en: "The Venice of the North", tr: "Kuzeyin Venedik'i" },
    why: {
      en: "Golden Age canals, Van Gogh and Rembrandt, and a cycling culture that makes the whole city feel like a village.",
      tr: "Altın Çağ kanalları, Van Gogh ve Rembrandt, tüm şehri köy gibi hissettiren bisiklet kültürü.",
    },
    highlights: {
      en: ["Rijksmuseum & Van Gogh Museum", "Canal ring by boat", "Cafés of the Jordaan"],
      tr: ["Rijksmuseum ve Van Gogh Müzesi", "Tekneyle kanal turu", "Jordaan kafeleri"],
    },
  },
  zurich: {
    tagline: { en: "Swiss precision, lakeside calm", tr: "İsviçre hassasiyeti, göl kıyısı huzuru" },
    why: {
      en: "A medieval old town on a crystal lake, world-class chocolate and the Alps an hour away.",
      tr: "Kristal bir gölün kıyısında orta çağ eski şehri, dünya çapında çikolata ve bir saat mesafede Alpler.",
    },
    highlights: {
      en: ["Lake Zurich & Bahnhofstrasse", "Old Town (Niederdorf)", "Uetliberg panorama"],
      tr: ["Zürih Gölü ve Bahnhofstrasse", "Eski Şehir (Niederdorf)", "Uetliberg panoraması"],
    },
  },
  geneva: {
    tagline: { en: "The capital of diplomacy", tr: "Diplomasinin başkenti" },
    why: {
      en: "The Jet d'Eau over Lac Léman, CERN's universe next door and Mont Blanc on the horizon.",
      tr: "Léman Gölü üzerinde Jet d'Eau, yanı başında CERN'in evreni ve ufukta Mont Blanc.",
    },
    highlights: {
      en: ["Jet d'Eau & the lakeside", "Old Town & St. Pierre", "CERN & Chamonix day trips"],
      tr: ["Jet d'Eau ve göl kıyısı", "Eski Şehir ve St. Pierre", "CERN ve Chamonix gezileri"],
    },
  },
  berlin: {
    tagline: { en: "History, rewritten daily", tr: "Her gün yeniden yazılan tarih" },
    why: {
      en: "The Wall's remains, Museum Island, techno temples and Europe's most creative art and food scenes.",
      tr: "Berlin Duvarı'nın kalıntıları, Müzeler Adası, techno mabetleri ve Avrupa'nın en yaratıcı sanat ve yemek sahnesi.",
    },
    highlights: {
      en: ["East Side Gallery", "Museum Island", "Kreuzberg after dark"],
      tr: ["East Side Gallery", "Müzeler Adası", "Kreuzberg gece hayatı"],
    },
  },
  munich: {
    tagline: { en: "Bavaria's proud capital", tr: "Bavyera'nın gururlu başkenti" },
    why: {
      en: "Beer gardens, baroque palaces, Oktoberfest and river surfers in the English Garden — tradition with a wink.",
      tr: "Bira bahçeleri, barok saraylar, Oktoberfest ve English Garden'da nehir sörfçüleri — göz kırpan bir gelenek.",
    },
    highlights: {
      en: ["Marienplatz & Hofbräuhaus", "The English Garden", "Nymphenburg Palace"],
      tr: ["Marienplatz ve Hofbräuhaus", "English Garden", "Nymphenburg Sarayı"],
    },
  },
  "new-york": {
    tagline: { en: "The city that never sleeps", tr: "Hiç uyumayan şehir" },
    why: {
      en: "Skyline icons, Broadway lights, Central Park seasons and a food scene that spans the entire planet.",
      tr: "Silüet ikonları, Broadway ışıkları, Central Park'ın dört mevsimi ve tüm gezegeni kapsayan bir yemek sahnesi.",
    },
    highlights: {
      en: ["Times Square & Broadway", "Central Park", "Brooklyn Bridge & DUMBO"],
      tr: ["Times Square ve Broadway", "Central Park", "Brooklyn Köprüsü ve DUMBO"],
    },
  },
  "los-angeles": {
    tagline: { en: "The city of dreams", tr: "Hayaller şehri" },
    why: {
      en: "Hollywood glamour, Pacific sunsets, canyon hikes and taco trucks — endless summer with a film-reel heart.",
      tr: "Hollywood ihtişamı, Pasifik gün batımları, kanyon yürüyüşleri ve taco kamyonları — film makarası kalpli sonsuz yaz.",
    },
    highlights: {
      en: ["Hollywood & Walk of Fame", "Santa Monica & Venice", "Griffith Observatory views"],
      tr: ["Hollywood ve Şöhretler Kaldırımı", "Santa Monica ve Venice", "Griffith Gözlemevi manzarası"],
    },
  },
  miami: {
    tagline: { en: "The Magic City", tr: "Sihirli Şehir" },
    why: {
      en: "Pastel Art Deco streets, Cuban rhythm in Little Havana, South Beach energy and year-round ocean warmth.",
      tr: "Pastel Art Deco sokakları, Little Havana'da Küba ritmi, South Beach enerjisi ve yıl boyu ılık okyanus.",
    },
    highlights: {
      en: ["South Beach & Ocean Drive", "Wynwood Walls", "Little Havana"],
      tr: ["South Beach ve Ocean Drive", "Wynwood Walls", "Little Havana"],
    },
  },
  toronto: {
    tagline: { en: "The world in one city", tr: "Tek şehirde dünya" },
    why: {
      en: "The CN Tower above a lakefront metropolis where 180 languages are spoken and every cuisine has a neighbourhood.",
      tr: "180 dilin konuşulduğu, her mutfağın bir mahallesi olan göl kıyısı metropolünün üzerinde CN Kulesi.",
    },
    highlights: {
      en: ["CN Tower", "Kensington Market", "Toronto Islands & Niagara day trip"],
      tr: ["CN Kulesi", "Kensington Market", "Toronto Adaları ve Niagara gezisi"],
    },
  },
  vancouver: {
    tagline: { en: "Mountains meet the Pacific", tr: "Dağlar Pasifik'le buluşuyor" },
    why: {
      en: "Ski in the morning, sail in the afternoon — a glass-and-cedar city wrapped in rainforest and ocean.",
      tr: "Sabah kayak, öğleden sonra yelken — yağmur ormanı ve okyanusla sarılmış cam ve sedir şehri.",
    },
    highlights: {
      en: ["Stanley Park seawall", "Granville Island Market", "Grouse Mountain & Capilano Bridge"],
      tr: ["Stanley Park kıyı yolu", "Granville Island Pazarı", "Grouse Mountain ve Capilano Köprüsü"],
    },
  },
  montreal: {
    tagline: { en: "Europe's soul in North America", tr: "Kuzey Amerika'da Avrupa ruhu" },
    why: {
      en: "French joie de vivre, cobblestoned Old Montreal, bagels and poutine, and a festival for every season.",
      tr: "Fransız yaşam sevinci, arnavut kaldırımlı Eski Montreal, bagel ve poutine, her mevsim bir festival.",
    },
    highlights: {
      en: ["Old Montreal & Notre-Dame", "Mount Royal", "Plateau cafés & festivals"],
      tr: ["Eski Montreal ve Notre-Dame", "Mount Royal", "Plateau kafeleri ve festivaller"],
    },
  },
  "mexico-city": {
    tagline: { en: "An ancient capital reborn", tr: "Yeniden doğan kadim başkent" },
    why: {
      en: "Aztec ruins beneath colonial palaces, Frida Kahlo's blue house and one of the world's great food cities.",
      tr: "Sömürge saraylarının altında Aztek kalıntıları, Frida Kahlo'nun mavi evi ve dünyanın en büyük yemek şehirlerinden biri.",
    },
    highlights: {
      en: ["Zócalo & Templo Mayor", "Coyoacán & Frida Kahlo Museum", "Roma & Condesa dining"],
      tr: ["Zócalo ve Templo Mayor", "Coyoacán ve Frida Kahlo Müzesi", "Roma ve Condesa lezzetleri"],
    },
  },
  cancun: {
    tagline: { en: "The gateway to the Maya world", tr: "Maya dünyasına açılan kapı" },
    why: {
      en: "Caribbean water in seven shades of blue, cenotes hidden in the jungle and Chichén Itzá a day trip away.",
      tr: "Yedi ton mavi Karayip suyu, ormanda saklı cenote'ler ve günübirlik mesafede Chichén Itzá.",
    },
    highlights: {
      en: ["Hotel Zone beaches", "Cenotes & Isla Mujeres", "Chichén Itzá"],
      tr: ["Otel bölgesi plajları", "Cenote'ler ve Isla Mujeres", "Chichén Itzá"],
    },
  },
  dubai: {
    tagline: { en: "The future, built yesterday", tr: "Dün inşa edilen gelecek" },
    why: {
      en: "The world's tallest tower, man-made islands, desert safaris and gold souks — ambition turned into skyline.",
      tr: "Dünyanın en yüksek kulesi, yapay adalar, çöl safarileri ve altın çarşıları — silüete dönüşmüş hırs.",
    },
    highlights: {
      en: ["Burj Khalifa & Dubai Mall", "Desert safari", "Old Dubai & the Gold Souk"],
      tr: ["Burj Khalifa ve Dubai Mall", "Çöl safarisi", "Eski Dubai ve Altın Çarşısı"],
    },
  },
  "abu-dhabi": {
    tagline: { en: "The serene capital", tr: "Sakin başkent" },
    why: {
      en: "The Sheikh Zayed Grand Mosque's marble splendour, the Louvre Abu Dhabi and Saadiyat's white-sand calm.",
      tr: "Şeyh Zayid Camii'nin mermer ihtişamı, Louvre Abu Dhabi ve Saadiyat'ın beyaz kumlu huzuru.",
    },
    highlights: {
      en: ["Sheikh Zayed Grand Mosque", "Louvre Abu Dhabi", "Yas Island"],
      tr: ["Şeyh Zayid Camii", "Louvre Abu Dhabi", "Yas Adası"],
    },
  },
  riyadh: {
    tagline: { en: "Arabia's rising giant", tr: "Arabistan'ın yükselen devi" },
    why: {
      en: "Masmak Fortress heritage, Boulevard City spectacle and the Edge of the World's desert cliffs nearby.",
      tr: "Masmak Kalesi mirası, Boulevard City gösterişi ve yakınlarda Edge of the World'ün çöl uçurumları.",
    },
    highlights: {
      en: ["Masmak Fortress & Diriyah", "Kingdom Centre skybridge", "Edge of the World"],
      tr: ["Masmak Kalesi ve Diriyah", "Kingdom Centre gökyüzü köprüsü", "Edge of the World"],
    },
  },
  cairo: {
    tagline: { en: "The city of a thousand minarets", tr: "Bin minareli şehir" },
    why: {
      en: "The last Wonder of the Ancient World at its doorstep — pyramids, the Nile and Khan el-Khalili's maze.",
      tr: "Antik Dünyanın ayakta kalan son harikası kapısında — piramitler, Nil ve Han el-Halili'nin labirenti.",
    },
    highlights: {
      en: ["Giza Pyramids & the Sphinx", "The Egyptian Museum", "Khan el-Khalili & a Nile felucca"],
      tr: ["Gize Piramitleri ve Sfenks", "Mısır Müzesi", "Han el-Halili ve Nil felukası"],
    },
  },
  doha: {
    tagline: { en: "The Gulf's quiet showpiece", tr: "Körfez'in sessiz vitrini" },
    why: {
      en: "A skyline rising from the sea, the Museum of Islamic Art, Souq Waqif's falcons and dunes that meet the water.",
      tr: "Denizden yükselen bir silüet, İslam Eserleri Müzesi, Souq Waqif'in şahinleri ve suyla buluşan kumullar.",
    },
    highlights: {
      en: ["Museum of Islamic Art", "Souq Waqif", "Inland Sea desert safari"],
      tr: ["İslam Eserleri Müzesi", "Souq Waqif", "Inland Sea çöl safarisi"],
    },
  },
  bangkok: {
    tagline: { en: "The city of angels", tr: "Melekler şehri" },
    why: {
      en: "Golden temples beside rooftop bars, canal markets, Michelin-starred street food and tuk-tuk chaos you will love.",
      tr: "Çatı barlarının yanında altın tapınaklar, kanal pazarları, Michelin yıldızlı sokak lezzetleri ve seveceğiniz tuk-tuk kaosu.",
    },
    highlights: {
      en: ["Grand Palace & Wat Pho", "Chao Phraya & floating markets", "Street food in Chinatown"],
      tr: ["Büyük Saray ve Wat Pho", "Chao Phraya ve yüzen pazarlar", "Chinatown sokak lezzetleri"],
    },
  },
  phuket: {
    tagline: { en: "Thailand's island flagship", tr: "Tayland'ın amiral adası" },
    why: {
      en: "Limestone bays, Phi Phi day trips, old-town shophouses and sunsets over the Andaman Sea.",
      tr: "Kalker koyları, Phi Phi günübirlik turları, eski şehir dükkânları ve Andaman Denizi'nde gün batımları.",
    },
    highlights: {
      en: ["Phi Phi & Phang Nga Bay", "Old Phuket Town", "Big Buddha & Kata viewpoint"],
      tr: ["Phi Phi ve Phang Nga Körfezi", "Eski Phuket Town", "Big Buddha ve Kata seyir noktası"],
    },
  },
  tokyo: {
    tagline: { en: "Tomorrow, today", tr: "Yarın, bugün" },
    why: {
      en: "Neon Shibuya crossings, silent shrines, Michelin-starred ramen and the world's most punctual wonder.",
      tr: "Neon Shibuya kavşakları, sessiz tapınaklar, Michelin yıldızlı ramen ve dünyanın en dakik harikası.",
    },
    highlights: {
      en: ["Shibuya & Shinjuku", "Senso-ji & Meiji Shrine", "Tsukiji outer market & teamLab"],
      tr: ["Shibuya ve Shinjuku", "Senso-ji ve Meiji Tapınağı", "Tsukiji dış pazarı ve teamLab"],
    },
  },
  osaka: {
    tagline: { en: "Japan's kitchen", tr: "Japonya'nın mutfağı" },
    why: {
      en: "Takoyaki in Dotonbori's neon canyon, Osaka Castle and the friendliest locals in Japan.",
      tr: "Dotonbori'nin neon kanyonunda takoyaki, Osaka Kalesi ve Japonya'nın en sıcak insanları.",
    },
    highlights: {
      en: ["Dotonbori", "Osaka Castle", "Universal Studios Japan"],
      tr: ["Dotonbori", "Osaka Kalesi", "Universal Studios Japan"],
    },
  },
  seoul: {
    tagline: { en: "Where palaces meet K-pop", tr: "Sarayların K-pop'la buluştuğu yer" },
    why: {
      en: "Joseon palaces, hanbok strolls in Bukchon, 24-hour BBQ and the world's fastest everything.",
      tr: "Joseon sarayları, Bukchon'da hanbok yürüyüşleri, 24 saat BBQ ve dünyanın en hızlı her şeyi.",
    },
    highlights: {
      en: ["Gyeongbokgung Palace", "Bukchon Hanok Village", "Myeongdong & the Han River"],
      tr: ["Gyeongbokgung Sarayı", "Bukchon Hanok Köyü", "Myeongdong ve Han Nehri"],
    },
  },
  singapore: {
    tagline: { en: "The garden city of the future", tr: "Geleceğin bahçe şehri" },
    why: {
      en: "Supertrees glowing at dusk, hawker-centre feasts, rooftop infinity pools and the planet's best airport.",
      tr: "Alacakaranlıkta parlayan Süper Ağaçlar, hawker ziyafetleri, sonsuzluk havuzları ve gezegenin en iyi havalimanı.",
    },
    highlights: {
      en: ["Gardens by the Bay", "Marina Bay Sands", "Hawker centres & Sentosa"],
      tr: ["Gardens by the Bay", "Marina Bay Sands", "Hawker merkezleri ve Sentosa"],
    },
  },
  "new-delhi": {
    tagline: { en: "Eight cities in one", tr: "Tek şehirde sekiz şehir" },
    why: {
      en: "Mughal tombs and imperial boulevards, Chandni Chowk's spice clouds and the Taj Mahal three hours away.",
      tr: "Babür türbeleri ve imparatorluk bulvarları, Chandni Chowk'un baharat bulutları ve üç saat mesafede Tac Mahal.",
    },
    highlights: {
      en: ["Humayun's Tomb & Qutub Minar", "Old Delhi food walk", "India Gate & Lodi Gardens"],
      tr: ["Humayun Türbesi ve Qutub Minar", "Eski Delhi lezzet turu", "India Gate ve Lodi Bahçeleri"],
    },
  },
  mumbai: {
    tagline: { en: "The Maximum City", tr: "Maksimum Şehir" },
    why: {
      en: "Bollywood, the Gateway of India, colonial facades and street food that fuels twenty million dreams.",
      tr: "Bollywood, Gateway of India, sömürge cepheleri ve yirmi milyon hayali besleyen sokak lezzetleri.",
    },
    highlights: {
      en: ["Gateway of India & Marine Drive", "Elephanta Caves", "Street food tours"],
      tr: ["Gateway of India ve Marine Drive", "Elephanta Mağaraları", "Sokak lezzeti turları"],
    },
  },
  beijing: {
    tagline: { en: "The imperial capital", tr: "İmparatorluk başkenti" },
    why: {
      en: "The Forbidden City, the Great Wall snaking over mountains and hutong lanes hiding Peking duck masters.",
      tr: "Yasak Şehir, dağların üzerinde kıvrılan Çin Seddi ve Pekin ördeği ustalarını saklayan hutong sokakları.",
    },
    highlights: {
      en: ["Great Wall at Mutianyu", "The Forbidden City", "Hutongs & Temple of Heaven"],
      tr: ["Mutianyu'da Çin Seddi", "Yasak Şehir", "Hutonglar ve Cennet Tapınağı"],
    },
  },
  shanghai: {
    tagline: { en: "The Pearl of the Orient", tr: "Doğu'nun İncisi" },
    why: {
      en: "The Bund's Art Deco facing Pudong's sci-fi towers — 1920s glamour and a 2050s skyline in one frame.",
      tr: "Pudong'un bilim kurgu kulelerine bakan Bund'un Art Deco'su — tek karede 1920'lerin ihtişamı ve 2050'lerin silüeti.",
    },
    highlights: {
      en: ["The Bund & Pudong", "Yu Garden", "The French Concession"],
      tr: ["The Bund ve Pudong", "Yu Bahçesi", "Fransız İmtiyaz Bölgesi"],
    },
  },
  sydney: {
    tagline: { en: "The harbour city", tr: "Liman şehri" },
    why: {
      en: "Opera House sails over the world's most beautiful harbour, with surf beaches minutes from downtown.",
      tr: "Opera Evi'nin yelkenleri dünyanın en güzel limanının üzerinde, sörf plajları şehir merkezine dakikalar uzaklıkta.",
    },
    highlights: {
      en: ["Opera House & Harbour Bridge", "Bondi to Coogee walk", "Blue Mountains day trip"],
      tr: ["Opera Evi ve Harbour Bridge", "Bondi'den Coogee'ye yürüyüş", "Blue Mountains gezisi"],
    },
  },
  melbourne: {
    tagline: { en: "Australia's culture capital", tr: "Avustralya'nın kültür başkenti" },
    why: {
      en: "Laneway cafés and street art, the world's best coffee culture and the Great Ocean Road at the doorstep.",
      tr: "Ara sokak kafeleri ve sokak sanatı, dünyanın en iyi kahve kültürü ve kapıda Great Ocean Road.",
    },
    highlights: {
      en: ["Laneways & coffee culture", "Federation Square & the NGV", "Great Ocean Road"],
      tr: ["Ara sokaklar ve kahve kültürü", "Federation Square ve NGV", "Great Ocean Road"],
    },
  },
  auckland: {
    tagline: { en: "The city of sails", tr: "Yelkenliler şehri" },
    why: {
      en: "Two harbours, fifty volcanic cones, island wineries fifteen minutes away and Māori heritage woven through it all.",
      tr: "İki liman, elli volkanik tepe, on beş dakikada ada şaraphaneleri ve her yere işlenmiş Maori mirası.",
    },
    highlights: {
      en: ["Sky Tower & the Viaduct", "Waiheke Island wineries", "Mount Eden crater"],
      tr: ["Sky Tower ve Viaduct", "Waiheke Adası şaraphaneleri", "Mount Eden krateri"],
    },
  },
  queenstown: {
    tagline: { en: "The adventure capital of the world", tr: "Dünyanın macera başkenti" },
    why: {
      en: "Bungee was born here — jet boats, ski fields and Milford Sound, all wrapped in Remarkables peaks.",
      tr: "Bungee burada doğdu — jet boat'lar, kayak pistleri ve Milford Sound, hepsi Remarkables zirveleriyle çevrili.",
    },
    highlights: {
      en: ["Skyline gondola & luge", "Milford Sound", "Bungee & jet boating"],
      tr: ["Skyline teleferiği ve luge", "Milford Sound", "Bungee ve jet boat"],
    },
  },
  male: {
    tagline: { en: "The gateway to paradise", tr: "Cennete açılan kapı" },
    why: {
      en: "A pint-sized island capital where your seaplane waits — 1,192 coral islands of barefoot luxury beyond.",
      tr: "Deniz uçağınızın beklediği minicik bir ada başkenti — ötesinde yalınayak lüksün 1.192 mercan adası.",
    },
    highlights: {
      en: ["Seaplane arrival", "Local markets & the Old Friday Mosque", "Resort atolls & diving"],
      tr: ["Deniz uçağıyla varış", "Yerel pazarlar ve Eski Cuma Camii", "Resort atolleri ve dalış"],
    },
  },
  mahe: {
    tagline: { en: "Granite and jungle island", tr: "Granit ve orman adası" },
    why: {
      en: "Giant granite boulders on white sand, Creole culture and rainforest peaks above Beau Vallon.",
      tr: "Beyaz kumda dev granit kayalar, Kreol kültürü ve Beau Vallon'un üzerinde yağmur ormanı zirveleri.",
    },
    highlights: {
      en: ["Beau Vallon beach", "Morne Seychellois trails", "Victoria market & Eden Island"],
      tr: ["Beau Vallon plajı", "Morne Seychellois parkurları", "Victoria pazarı ve Eden Island"],
    },
  },
  bali: {
    tagline: { en: "The Island of the Gods", tr: "Tanrıların Adası" },
    why: {
      en: "Emerald rice terraces, clifftop temples, surf breaks and a spiritual calm you feel the moment you land.",
      tr: "Zümrüt pirinç terasları, uçurum tapınakları, sörf dalgaları ve iner inmez hissettiğiniz ruhani bir huzur.",
    },
    highlights: {
      en: ["Uluwatu Temple", "Tegalalang rice terraces", "Ubud & the waterfalls"],
      tr: ["Uluwatu Tapınağı", "Tegalalang pirinç terasları", "Ubud ve şelaleler"],
    },
  },
  "punta-cana": {
    tagline: { en: "The Caribbean's easy smile", tr: "Karayipler'in rahat gülümsemesi" },
    why: {
      en: "Thirty kilometres of palm-lined white sand, all-inclusive ease and cenote-blue lagoons to explore.",
      tr: "Otuz kilometre palmiyeli beyaz kum, her şey dahil rahatlık ve keşfedilecek cenote mavisi lagünler.",
    },
    highlights: {
      en: ["Bávaro Beach", "Saona Island by catamaran", "Hoyo Azul lagoon"],
      tr: ["Bávaro Plajı", "Katamarla Saona Adası", "Hoyo Azul lagünü"],
    },
  },
  "port-louis": {
    tagline: { en: "Mauritius' Creole heartbeat", tr: "Mauritius'un Kreol kalbi" },
    why: {
      en: "A harbour capital of markets and temples, street-side dholl puri and the island's multicultural soul.",
      tr: "Pazarları ve tapınaklarıyla bir liman başkenti, sokakta dholl puri ve adanın çok kültürlü ruhu.",
    },
    highlights: {
      en: ["The Central Market", "Caudan Waterfront", "Aapravasi Ghat & Chinatown"],
      tr: ["Merkez Pazarı", "Caudan Waterfront", "Aapravasi Ghat ve Chinatown"],
    },
  },
  nadi: {
    tagline: { en: "Fiji's smiling doorstep", tr: "Fiji'nin gülen kapısı" },
    why: {
      en: "The 'Bula!' welcome starts here — Hindu temple colour, hot-spring mud pools and the Yasawa islands a boat ride away.",
      tr: "'Bula!' selamı burada başlar — Hindu tapınağı renkleri, çamur havuzları ve tekne mesafesinde Yasawa adaları.",
    },
    highlights: {
      en: ["Sri Siva Subramaniya Temple", "Sabeto mud pools", "Mamanuca & Yasawa day trips"],
      tr: ["Sri Siva Subramaniya Tapınağı", "Sabeto çamur havuzları", "Mamanuca ve Yasawa turları"],
    },
  },
  "bora-bora": {
    tagline: { en: "The pearl of the Pacific", tr: "Pasifik'in incisi" },
    why: {
      en: "A lagoon in fifty shades of turquoise beneath Mount Otemanu — the world's most photographed honeymoon.",
      tr: "Otemanu Dağı'nın eteğinde elli ton turkuaz bir lagün — dünyanın en çok fotoğraflanan balayı.",
    },
    highlights: {
      en: ["Lagoon snorkel with rays", "Mount Otemanu views", "Overwater bungalows"],
      tr: ["Vatozlarla lagün şnorkeli", "Otemanu Dağı manzarası", "Su üstü bungalovlar"],
    },
  },
};

export function getCityContent(slug, lang) {
  const c = CONTENT[slug];
  if (!c) return null;
  const pick = (o) => (o ? o[lang] || o.en : undefined);
  return { tagline: pick(c.tagline), why: pick(c.why), highlights: pick(c.highlights) };
}
